import { useContext } from "react";
import GlobalLoaderContext, { GlobalLoaderContextType } from "@/contexts/GlobalLoaderContext";

export function useGlobalLoader(): GlobalLoaderContextType {
  const context = useContext(GlobalLoaderContext);

  if (!context) {
    throw new Error("useGlobalLoader must be used within a GlobalLoaderProvider");
  }

  return context;
}
